import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { ConnectorAvatar } from '#pplx/frontend/apps/ask/connectors/components/ConnectorAvatar.js';
import { resolveSourceAvatarUrl } from '#pplx/frontend/apps/ask/connectors/utils/connectors.js';
export function ComputerMenuItemIcon({ item }) {
    if (item.action.type === 'connector') {
        return (_jsx(ConnectorAvatar, { connectorAvatar: resolveSourceAvatarUrl(item.action.source), name: "", size: "small" }));
    }
    return _jsx(Icon, { icon: item.icon, size: "small" });
}
//# sourceMappingURL=ComputerMenuItemIcon.js.map